module.exports = __webpack_public_path__ + "static/media/LOGO-U-MESSENGER.6a977538.png";